// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"carousel_carouselWrapper__q6Vis","leftNavigation":"carousel_leftNavigation__Vo4-X","rightNavigation":"carousel_rightNavigation__ik7RQ"};